import { render, staticRenderFns } from "./RatingStars.vue?vue&type=template&id=0a3ed4ae"
import script from "./RatingStars.vue?vue&type=script&lang=js"
export * from "./RatingStars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/share/honeypot.learningsystem.de/releases/20260624084000/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a3ed4ae')) {
      api.createRecord('0a3ed4ae', component.options)
    } else {
      api.reload('0a3ed4ae', component.options)
    }
    module.hot.accept("./RatingStars.vue?vue&type=template&id=0a3ed4ae", function () {
      api.rerender('0a3ed4ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/RatingStars.vue"
export default component.exports